import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { useRef, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import sift from "sift";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import config from "../../../../config";
import { useApi } from "../../../../api";
import { qs, range } from "../../../../utils"; // Components

import Icon from "../../../../components/Icon";
import Button from "../../../../components/Button";
import Package from "../../../../components/Package";
import { RecentSearches, saveRecentSearch, getRecentSearch } from "../../../../components/UserMenu";
import Filter from "./Filter";
import "./Filters.scss";

var rangeFields = ["price", "bedrooms", "bathrooms", "parking", "stories", "frontage", "landSize"],
    LandComponent = function LandComponent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--checklist ta-filter--checklist--lfs"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "ta-filter--title"
  }, "Land for sale", /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--item"
  }, /*#__PURE__*/React.createElement("a", {
    href: config.routes.get("landforsale.results")
  }, /*#__PURE__*/React.createElement("div", {
    className: "checklist checklist__large"
  }, /*#__PURE__*/React.createElement("span", {
    className: "checkbox checkbox__icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "land",
    className: "label"
  }, "Land"))))));
}; // @TODO remove quick fix of onlyLotsFilters and create a search criteria for landforsale


export var Filters = function Filters(a) {
  var b = a.filters,
      c = a.defaultValues,
      d = void 0 === c ? {} : c,
      f = a.onlyLotsFilters,
      g = a.isResultPage,
      h = a.history,
      i = a.containsLand,
      j = a.noAdvancedSearch,
      k = a.showNeibourhood,
      l = !(void 0 !== k) || k,
      m = b.estate,
      n = b.neighbourhood,
      o = b.propertyType,
      p = b.price,
      q = b.bedrooms,
      r = b.bathrooms,
      s = b.parking,
      t = b.stories,
      u = b.landSize,
      v = b.frontage,
      w = b.builder,
      x = b.otherOptions,
      y = b.statusOptions,
      z = useApi(),
      A = useState({}),
      B = _slicedToArray(A, 2),
      C = B[0],
      D = B[1],
      E = function onToggle(a) {
    D(_objectSpread({}, C, _defineProperty({}, a, !C[a])));
  },
      F = useState(!1),
      G = _slicedToArray(F, 2),
      H = G[0],
      I = G[1],
      J = useState(d),
      K = _slicedToArray(J, 2),
      L = K[0],
      M = K[1];

  useEffect(function () {
    M(d);
  }, [d]); // eslint-disable-line

  var N = function N(a) {
    var b = a.name,
        c = a.value;
    return M(_objectSpread({}, L, _defineProperty({}, b, c || void 0)));
  },
      O = function O(a, b) {
    var c = (b || {}).all;
    a.preventDefault(); // re-assign some params for the url

    var d = c ? {} : _objectSpread({}, L);
    f || !o || d.propertyType || (d.propertyType = o.options.map(function (a) {
      var b = a.value;
      return b;
    })), rangeFields.map(function (a) {
      // const filter = filters[name];
      var b = d[a] ? d[a] : null;
      return b && (d[a] = range.stringify(b)), b;
    }), d.type = d.propertyType, d.land_size = d.landSize, d.other_options = d.otherOptions, d.featured_options = d.statusOptions, delete d.propertyType, delete d.landSize, delete d.otherOptions, delete d.statusOptions;

    var e = qs.parse(window.location.search),
        i = qs.stringify(_objectSpread({}, e, {}, d)),
        j = _objectSpread({}, e, {}, d);

    delete j.sort;
    var k = qs.stringify(_objectSpread({}, j, {
      type: f ? "land" : j.type
    }));
    saveRecentSearch(k); // }

    var l = f ? config.routes.get("landforsale.results") : config.routes.get("property.results"),
        m = "".concat(l, "?").concat(i);
    g ? (D({}), h.push(m)) : window.location.href = m;
  },
      P = useState(!1),
      Q = _slicedToArray(P, 2),
      R = Q[0],
      S = Q[1],
      T = classnames("advancedsearch", {
    isActive: R
  }),
      U = L.estate && !L.estate.length,
      V = L.neighbourhood && !L.neighbourhood.length,
      W = L.otherOptions && !L.otherOptions.length,
      X = L.propertyType && !L.propertyType.length,
      Y = l && n ? f ? n.options.filter(function (a) {
    return a.landforsale;
  }) : n.options.filter(function (a) {
    return a.packages;
  }) : [];

  l = 1 < Y.length;
  var Z = f ? z.lots.list() : z.packages.list();
  x.options = x.options.filter(function (a) {
    return Z.find(sift({
      attributes: {
        $in: [a.value]
      }
    }));
  });

  var $ = f ? 1 < x.options.length : !j,
      _ = useRef(),
      aa = function aa() {
    993 > window.innerWidth && I(!H), !H && 993 > window.innerWidth && disableBodyScroll(_.current), H && 993 > window.innerWidth && enableBodyScroll(_.current);
  },
      ba = L.propertyToCompare,
      ca = getRecentSearch();

  return /*#__PURE__*/React.createElement("section", {
    className: classnames("ta-filter", {
      noAdvancedSearch: j
    })
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: O,
    className: classnames({
      active: H
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row ta-filter--heading"
  }, /*#__PURE__*/React.createElement("h2", null, ba ? "Your chosen property" : /*#__PURE__*/React.createElement(React.Fragment, null, "Refine your search", H ? /*#__PURE__*/React.createElement(Icon, {
    icon: "close_black",
    onClick: aa
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: "filter",
    onClick: aa
  })))), ba ? /*#__PURE__*/React.createElement("span", {
    ref: _,
    className: classnames("ta-filter--fieldswrapper active")
  }, /*#__PURE__*/React.createElement(Package, {
    className: "ta-filter--similar-properties-package",
    data: ba,
    propertyToCompare: !1,
    summary: !0
  }), ca.length ? /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--recent-searches__wrapper"
  }, /*#__PURE__*/React.createElement("h2", null, "Recent Searches"), /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement(RecentSearches, {
    className: "ta-filter--recent-searches"
  }))) : null) : /*#__PURE__*/React.createElement("span", {
    ref: _,
    className: classnames("ta-filter--fieldswrapper", {
      active: H
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "ta-filter--fieldswrapper__scroll"
  }, m ? /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, m, {
    onChange: N,
    value: L.estate,
    name: "estate",
    className: "ta-filter--checklist ta-filter--estates",
    required: U,
    allSelectedByDefault: !0,
    hideCheckIcon: !0
  }))) : null, l && n ? /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, n, {
    options: Y,
    onChange: N,
    value: L.neighbourhood,
    name: "neighbourhood",
    className: "ta-filter--checklist",
    required: V,
    allSelectedByDefault: !0,
    showSelectAll: !0,
    hideCheckIcon: !0
  }))) : null, f ? null : /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, o, {
    onChange: N,
    value: L.propertyType,
    name: "propertyType",
    className: "ta-filter--checklist",
    size: "large",
    allSelectedByDefault: !0,
    showSelectAll: !0,
    required: X
  })), i && !g ? /*#__PURE__*/React.createElement(LandComponent, null) : null, /*#__PURE__*/React.createElement(Filter, Object.assign({}, p, {
    onChange: N,
    className: "ta-filter--range",
    value: L.price,
    minOptionLabel: "MIN PRICE",
    maxOptionLabel: "MAX PRICE",
    currency: !0
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, f ? null : /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, q, {
    onChange: N,
    value: L.bedrooms,
    className: "ta-filter--range",
    onToggle: function onToggle() {
      return E("bedrooms");
    },
    toggled: C.bedrooms
  })), /*#__PURE__*/React.createElement(Filter, Object.assign({}, r, {
    onChange: N,
    value: L.bathrooms,
    className: "ta-filter--range",
    onToggle: function onToggle() {
      return E("bathrooms");
    },
    toggled: C.bathrooms
  })), /*#__PURE__*/React.createElement(Filter, Object.assign({}, s, {
    onChange: N,
    value: L.parking,
    className: "ta-filter--range",
    onToggle: function onToggle() {
      return E("parking");
    },
    toggled: C.parking
  })), /*#__PURE__*/React.createElement(Filter, Object.assign({}, t, {
    onChange: N,
    value: L.stories,
    className: "ta-filter--range",
    onToggle: function onToggle() {
      return E("stories");
    },
    toggled: C.stories
  })))), /*#__PURE__*/React.createElement("div", {
    className: classnames("ta-row", _defineProperty({}, T, !f))
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, u, {
    onChange: N,
    name: "landSize",
    value: L.landSize,
    className: classnames("ta-filter--range", {
      noAdvancedSearch: j
    }),
    suffix: "m\xB2"
  })), /*#__PURE__*/React.createElement(Filter, Object.assign({}, v, {
    onChange: N,
    value: L.frontage,
    className: classnames("ta-filter--range", {
      noAdvancedSearch: j
    }),
    suffix: "m"
  })), f ? null : /*#__PURE__*/React.createElement(Filter, Object.assign({}, w, {
    onChange: N,
    value: L.builder,
    className: classnames("ta-filter--range", {
      noAdvancedSearch: j
    })
  })), 0 < y.options.length && !j ? /*#__PURE__*/React.createElement("div", {
    className: "status-options"
  }, /*#__PURE__*/React.createElement(Filter, Object.assign({}, y, {
    onChange: N,
    value: L.statusOptions,
    name: "statusOptions",
    className: "ta-filter--checklist"
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: classnames(T, "ta-row", "other-options")
  }, 1 < x.options.length ? /*#__PURE__*/React.createElement(Filter, Object.assign({}, x, {
    onChange: N,
    value: L.otherOptions,
    name: "otherOptions",
    showSelectAll: !0,
    className: "ta-filter--checklist",
    required: W,
    allSelectedByDefault: !0
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "ta-row ta-filter--extra"
  }, $ && !j ? /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--extra__toggle",
    onClick: function toggleAdvancedSearch() {
      S(!R);
    }
  }, "Advanced Search") : null, /*#__PURE__*/React.createElement("div", {
    className: classnames("ta-filter--extra__reset", {
      single: !$
    }),
    onClick: function onClick() {
      return M({});
    }
  }, "Reset"), /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--extra__submit"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "large",
    disabled: U || V || X || W,
    onClick: aa
  }, g ? "Update" : "Search"), g || f ? null : /*#__PURE__*/React.createElement("div", {
    className: "view-all",
    onClick: function onClick(a) {
      return O(a, {
        all: !0
      });
    }
  }, "View all properties")))))));
};
export default withRouter(Filters);